/**
 * @typedef { import('../Dropdown').PanelOption } PanelOption
 */

/**
 * Filter an array of options to only show the children of a specific parent
 * @param {PanelOption[]} options
 * @param {string | number} parentName
 * @returns {PanelOption[]}
 */
export const filterOptionsByparentName = (options, parentName) =>
  options.reduce((acc, curr) => {
    // @ts-ignore
    if (curr.id === parentName) return acc.concat(curr.child);
    // @ts-ignore
    if (curr.child) return acc.concat(filterOptionsByparentName(curr.child, parentName));
    return acc;
  }, []);

/**
 * Filter an array of options to only show the children whose name value contains the filter string
 * @param {PanelOption[]} options
 * @param {string} filterString
 * @param {string} filterBy
 * @param {string[]} matchBy
 * @returns {PanelOption[]}
 */
export const filterOptionsByString = (options, filterString, filterBy, matchBy) => {
  if (options.length && filterString) {
    const sanitized = filterString.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&');
    const startsWith = filterBy === 'startsWith' ? '^' : '';
    const query = new RegExp(`${startsWith}${sanitized}`, 'i');

    // @ts-ignore
    return options.reduce((acc, curr) => {
      if (filterBy === 'contains' && curr.child) {
        if (filterOptionsByString(curr.child, filterString, filterBy, matchBy).length) {
          // @ts-ignore
          return acc.concat(curr);
        }
      }

      const hasMatch = matchBy.some((key) => curr[key] && !!`${curr[key]}`.match(query));
      if (hasMatch || (curr.parentName && curr.parentName.match(query))) {
        // @ts-ignore
        return acc.concat(curr);
      }
      return acc;
    }, []);
  }
  return options;
};

/**
 * Flatten an array of options for presentation purposes. Used with showGroups prop
 * @param {PanelOption[]} options
 * @param {string | number?} parentName
 * @returns {PanelOption[]}
 */
export const flattenArray = (options, parentName = '', depth = 1) =>
  options.reduce((acc, curr) => {
    if (curr.child) {
      return acc
        .concat({
          // @ts-ignore
          depth,
          id: curr.id,
          name: curr.name,
          disabled: curr.disabled || false,
          highlight: curr.highlight,
          parentName,
          child: curr.child,
          // @ts-ignore
        })
        .concat(flattenArray(curr.child, curr.name, depth + 1));
    }
    return acc.concat({
      // @ts-ignore
      id: curr.id,
      name: curr.name,
      disabled: curr.disabled || false,
      highlight: curr.highlight,
      parentName,
      depth,
    });
  }, []);

/**
 * Combination formatter for options
 * @param {PanelOption[]} array
 * @param {string | number} parentName - id passed to filterOptionsByparentName
 * @param {boolean} showGroups - toggle whether to flatten nested options
 * @returns {PanelOption[]}
 */
export const formatOptions = (array, parentName, showGroups) => {
  let formatted = array;
  if (showGroups) {
    formatted = flattenArray(array);
  }
  if (parentName) {
    formatted = filterOptionsByparentName(array, parentName);
  }
  return formatted;
};

/**
 *
 * @param {{name: string}[] | {name: string}} value
 * @returns {string}
 */
export const internalFormat = (value) => {
  if (!Array.isArray(value) && value.name) return value.name;
  return (
    value
      // @ts-ignore
      .map((curr) => curr.name)
      .sort()
      .reduce((acc, curr) => (acc ? `${acc}, ${curr}` : curr), '')
  );
};

export const Stub = () => {};
